/**
 * Fixed UI copy of the cookie bar and the cookie settings (Figma 60326:22711, 60326:23645 and the
 * mobile frames 60370:44022, 60370:44684). It is not administration content; the strings the core
 * dictionary has (`text275` „Používame cookies“, `text855` „Nastavenia“, `text2079` „Prijať všetky“,
 * `text272` „Zavrieť“) are translated with `t()` instead.
 */
export const COOKIES_COPY = {
  text: 'Pomáhajú nám, aby e-shop fungoval, aby sme vám ukázali relevantné ponuky a zlepšovali nákup. Nevyhnutné cookies sú vždy zapnuté, ostatné len s vaším súhlasom.',
  policy: 'Zásady používania cookies',
  rejectAll: 'Odmietnuť všetky',
  settings: {
    title: 'Nastavenia cookies',
    intro:
      'Vyberte, ktoré cookies môžeme používať. Svoje rozhodnutie môžete kedykoľvek zmeniť v pätičke stránky (Cookies).',
    save: 'Uložiť výber',
  },
  categories: {
    necessary: {
      title: 'Nevyhnutné',
      description: 'Zabezpečujú košík, prihlásenie a bezpečnosť. Bez nich e-shop nefunguje.',
    },
    preferences: {
      title: 'Preferenčné',
      description: 'Zapamätajú si vaše nastavenia, napr. naposledy prezerané produkty.',
    },
    analytics: {
      title: 'Analytické',
      description: 'Anonymne merajú návštevnosť, aby sme vedeli e-shop zlepšovať.',
    },
    marketing: {
      title: 'Marketingové',
      description: 'Umožňujú zobrazovať relevantné reklamy na iných weboch.',
    },
  },
} as const;
